import { origin_point_engine_api } from '@/lib/axios-client'

export type ReviewAction = 'submit' | 'withdraw'

export function postEngineReviewAction(input: {
  engineId: string
  action: ReviewAction
}) {
  return origin_point_engine_api({
    url: `/engines/${input.engineId}/submit-review`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: { action: input.action },
  })
}
